const ExpoAppIntegrity: any = {};
export default ExpoAppIntegrity;
